import React from 'react';
import {
  Modal,
  ModalContent,
  IconButton,
  Image,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FullscreenImage = ({ isOpen, onClose, imgUrl }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    size="full"
    motionPreset="none"
    allowPinchZoom
  >
    <ModalContent
      bg="blackAlpha.900"
      alignItems="center"
      justifyContent="center"
      my="0"
      h="inherit"
      minH="unset"
      borderRadius="0"
      boxShadow="none"
      overflow="hidden"
    >
      <IconButton
        onClick={onClose}
        aria-label="Close"
        icon={<FontAwesomeIcon icon={[ 'fas', 'times' ]} size="lg" />}
        colorScheme="blackAlpha"
        rounded="full"
        position="absolute"
        right="2"
        top="2"
        zIndex="overlay"
      />
      <Image
        src={imgUrl}
        ignoreFallback
        fit="cover"
        maxH="full"
      />
    </ModalContent>
  </Modal>
);

export default FullscreenImage;
